import type { ColDef } from 'ag-grid-community'
import { buildPriceColDefs } from './priceColDefs'
import { buildBaseItemColDefs } from './itemColDefs.base'
import { buildProcItemColDefs } from './itemColDefs.proc'
import { buildCustomsColDefs, buildDatasheetColDef } from './itemColDefs.customs'
import type { ItemColDefsParams, ItemRow } from './itemColDefs.types'

// Публичные типы модуля оставлены здесь же — внешние импорты не менялись.
export type { ItemRow } from './itemColDefs.types'

/**
 * Сборщик колонок сетки позиций заявки. Сами определения живут в модулях
 * (правило «файлы ≤500 строк»): базовые колонки, ценовые, процессные и
 * нетарифка (даташит + итог проверки логиста, с 25.09.2026).
 */
export function buildItemColDefs(params: ItemColDefsParams): ColDef<ItemRow>[] {
  const {
    isAdmin,
    userRole,
    isProcurement,
    cnyRate,
    markupConstants,
    pricingReady,
    kpMode,
    selectedPrices,
    onSelectPrice,
    onOpenQuotes,
  } = params

  return [
    ...buildBaseItemColDefs(params),

    // Даташит — карточное поле позиции, рядом с артикулом и количеством.
    buildDatasheetColDef(params),

    // ── Ценовые столбцы — себестоимость в ₽ ─────────────────────────────────
    ...(!isProcurement
      ? buildPriceColDefs({
          isAdmin,
          userRole,
          cnyRate,
          markupConstants,
          pricingReady,
          kpMode,
          selectedPrices,
          onSelectPrice,
          onOpenQuotes,
        })
      : []),

    ...buildProcItemColDefs(params),

    // ── Нетарифка — итог проверки логиста (позиции из-за рубежа) ─────────────
    ...buildCustomsColDefs(),
  ]
}
